<template>
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="14" cy="14" r="14" fill="#D9D9D9"/>
    <path d="M9.06445 9.53906L18.4606 18.9352" stroke="black" stroke-width="2"/>
    <path d="M18.4609 9.53906L9.06481 18.9352" stroke="black" stroke-width="2"/>
  </svg>
</template>

<script>
export default {
  name: 'cross2Icon'
}
</script>

<style scoped>

</style>
